import { FAQEntry } from '@shared/components/faq/model/faq-entry.model';
import { FAQRouteNames } from '@pages/frequently-asked-questions/frequently-asked-questions.routes';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';

export enum FAQPageSections {
  SERVICES = 'SERVICES',
  INVOICES = 'INVOICES',
  CONSUMPTION = 'CONSUMPTION',
  PROCEDURES = 'PROCEDURES',
  NOTIFICATIONS = 'NOTIFICATIONS',
}

export type FaqGroup = {
  section: FAQPageSections | string;
  title: string;
  entries: FAQEntry[];
  route?: string[];
};

export type FaqPageTab = {
  id: true | FAQPageSections;
  tab: string;
  count: number;
  groups: FaqGroup[];
};

export const sectionToRoute = (section: FAQPageSections) => [
  ...AcRoutingService.FAQ_ROUTE(),
  FAQRouteNames.MORE_FAQ,
  section.toLowerCase(),
];

export const sectionGroupsFn = (): FaqGroup[] =>
  Object.values(FAQPageSections).map((section) => ({
    section: section,
    title: `FAQ.${section}.TITLE`,
    entries: [],
    route: sectionToRoute(section),
  }));
